import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're0006',
    ecrans: ['00-2'],
    params: ['id']
});
